(() => {
  const updateProduct = (root, source) => {
    if (!root || !source) return;
    const price = root.querySelector('[data-ag-price]');
    const compare = root.querySelector('[data-ag-compare-price]');
    const discount = root.querySelector('[data-ag-discount]');
    const installmentValue = root.querySelector('[data-ag-installment-value]');
    const title = root.querySelector('[data-ag-product-title]');
    const image = root.querySelector('[data-ag-product-image]');
    const hiddenVariant = root.querySelector('[data-ag-selected-variant]');
    const addButton = root.querySelector('[data-ag-add-button]');
    const available = source.dataset.available === 'true';
    if (price) price.textContent = source.dataset.price || '';
    if (compare) { compare.textContent = source.dataset.comparePrice || ''; compare.hidden = !source.dataset.comparePrice; }
    if (discount) { discount.textContent = source.dataset.discount ? `-${source.dataset.discount}%` : ''; discount.hidden = !source.dataset.discount; }
    if (installmentValue && source.dataset.installment) installmentValue.textContent = source.dataset.installment;
    if (title && source.dataset.productTitle) title.textContent = source.dataset.productTitle;
    if (image && source.dataset.image) { image.src = source.dataset.image; image.srcset = ''; image.alt = source.dataset.imageAlt || ''; }
    if (hiddenVariant) { hiddenVariant.value = source.dataset.variantId || ''; hiddenVariant.dataset.available = String(available); }
    if (addButton) addButton.disabled = !available;
    if (source.matches('[data-ag-sibling-select]')) {
      root.querySelectorAll('[data-ag-sibling-select]').forEach((button) => {
        const active = button === source;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const volumeLabel = root.querySelector('.ag-sibling-products__legend span');
      if (volumeLabel && source.dataset.volume) volumeLabel.textContent = `– ${source.dataset.volume}`;
    }
  };
  const activityControllers = new WeakMap();
  const getViewerRange = (hour) => {
    if (hour < 6) return { min: 40, max: 80 };
    if (hour < 9) return { min: 80, max: 120 };
    return { min: 200, max: 300 };
  };
  const getSaoPauloHour = () => Number(new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo', hour: '2-digit', hour12: false
  }).format(new Date()));
  const randomInteger = (min, max) => {
    const range = max - min + 1;
    if (window.crypto?.getRandomValues) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      const limit = Math.floor(0x100000000 / range) * range;
      if (values[0] < limit) return min + (values[0] % range);
    }
    return min + Math.floor(Math.random() * range);
  };
  const initActivityWidgets = (section) => {
    if (!section || activityControllers.has(section)) return;
    const data = section.dataset;
    if (data.agShowNotifications !== 'true') return;
    const viewers = section.querySelector('[data-ag-viewers-toast]');
    const viewerCount = section.querySelector('[data-ag-viewers-count]');
    const viewerCopy = section.querySelector('[data-ag-viewers-copy]');
    if (!viewerCopy) return;
    if (data.agShowViewers !== 'true') return;
    let viewerTimer;
    const activityMode = 'ESTIMATED';
    const updateViewerEstimate = () => {
      if (!viewers || !viewerCount || !viewerCopy) return;
      const range = getViewerRange(getSaoPauloHour());
      const key = 'ag-afrodite-viewers';
      let stored;
      try { stored = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { stored = null; }
      const now = Date.now();
      const storedIsValid = stored?.range?.min === range.min && stored?.range?.max === range.max
        && Number.isInteger(stored.viewerCount) && stored.viewerCount >= range.min && stored.viewerCount <= range.max
        && Number.isFinite(stored.timestamp);
      let count = storedIsValid && now - stored.timestamp < 180000 ? stored.viewerCount : randomInteger(range.min, range.max);
      if (storedIsValid && now - stored.timestamp >= 180000) {
        let delta = randomInteger(-4, 4);
        if (delta === 0) delta = randomInteger(0, 1) ? 1 : -1;
        count = Math.min(range.max, Math.max(range.min, stored.viewerCount + delta));
      }
      try { sessionStorage.setItem(key, JSON.stringify({ viewerCount: count, timestamp: now, range })); } catch {}
      viewerCount.textContent = String(count);
      viewerCount.hidden = false;
      viewerCopy.hidden = false;
      viewers.classList.add('is-visible');
      if (activityMode === 'ESTIMATED') scheduleViewerUpdate();
    };
    const scheduleViewerUpdate = () => {
      window.clearTimeout(viewerTimer);
      if (activityMode === 'ESTIMATED') viewerTimer = window.setTimeout(updateViewerEstimate, (120 + Math.floor(Math.random() * 121)) * 1000);
    };
    updateViewerEstimate();
    const controller = {
      destroy: () => {
        window.clearTimeout(viewerTimer);
      }
    };
    activityControllers.set(section, controller);
  };
  const destroyActivityWidgets = (section) => {
    const controller = section && activityControllers.get(section);
    if (controller) controller.destroy();
  };
  let initialCartPromise;
  const updateViewCartButtons = (itemCount) => {
    document.querySelectorAll('[data-ag-view-cart]').forEach((button) => {
      button.hidden = !(Number(itemCount) > 0);
    });
  };
  const fetchCartState = () => fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((response) => {
    if (!response.ok) throw new Error('Não foi possível consultar o carrinho.');
    return response.json();
  });
  const syncCartState = (cart) => {
    if (cart && typeof cart.item_count !== 'undefined') updateViewCartButtons(cart.item_count);
    return cart;
  };
  const setupCartSync = () => {
    if (!initialCartPromise) initialCartPromise = fetchCartState().then(syncCartState).catch(() => updateViewCartButtons(0));
    if (document.documentElement.dataset.agCartSyncReady === 'true') return;
    document.documentElement.dataset.agCartSyncReady = 'true';
    const handleCartEvent = (event) => {
      let cart = event.detail?.cart;
      if (typeof cart === 'string') {
        try { cart = JSON.parse(cart); } catch { cart = null; }
      }
      if (cart && typeof cart.item_count !== 'undefined') return syncCartState(cart);
      fetchCartState().then(syncCartState).catch(() => {});
    };
    document.addEventListener('cart:updated', handleCartEvent);
    document.addEventListener('cart:updated-items', handleCartEvent);
  };
  const init = (scope = document) => {
    setupCartSync();
    scope.querySelectorAll('[data-ag-activity]').forEach(initActivityWidgets);
    scope.querySelectorAll('[data-ag-view-cart]:not([data-ag-ready])').forEach((button) => {
      button.dataset.agReady = 'true';
      button.addEventListener('click', () => {
        const miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.open === 'function') miniCart.open();
      });
    });
    scope.querySelectorAll('[data-ag-sibling-select]:not([data-ag-ready])').forEach((button) => {
      button.dataset.agReady = 'true';
      button.addEventListener('click', () => updateProduct(button.closest('[data-ag-product-root]'), button));
    });
    scope.querySelectorAll('[data-ag-variant-select]:not([data-ag-ready])').forEach((select) => {
      select.dataset.agReady = 'true';
      select.addEventListener('change', () => updateProduct(select.closest('[data-ag-product-root]'), select.options[select.selectedIndex]));
    });
    scope.querySelectorAll('[data-ag-product-form]:not([data-ag-ready])').forEach((form) => {
      form.dataset.agReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const root = form.closest('[data-ag-product-root]');
        const button = root?.querySelector('[data-ag-add-button]');
        const status = root?.querySelector('[data-ag-cart-status]');
        if (!root || !button || button.disabled) return;
        const originalText = button.textContent;
        button.disabled = true;
        if (status) status.textContent = '';
        try {
          const cartRoot = window.Shopify?.routes?.root || '/';
          const payload = new FormData(form);
          const miniCart = document.querySelector('mini-cart');
          const sections = miniCart?.getSectionsToRender?.() || [];
          if (sections.length) {
            payload.append('sections', sections.map((section) => section.section).join(','));
            payload.append('sections_url', window.location.pathname);
          }
          const response = await fetch(`${cartRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Não foi possível adicionar o produto.');
          if (status) status.textContent = 'Produto adicionado ao carrinho.';
          if (miniCart && result.sections && typeof miniCart.renderContents === 'function') {
            miniCart.renderContents(result);
            miniCart.open();
          }
          const cart = await fetchCartState();
          syncCartState(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        } catch (error) {
          if (status) status.textContent = error instanceof Error ? error.message : 'Não foi possível adicionar o produto.';
        } finally {
          button.textContent = originalText;
          const active = root.querySelector('[data-ag-sibling-select].is-active');
          button.disabled = active ? active.dataset.available !== 'true' : root.querySelector('[data-ag-selected-variant]')?.dataset.available !== 'true';
        }
      });
    });
    scope.querySelectorAll('[data-ag-quantity]:not([data-ag-ready])').forEach((quantity) => {
      quantity.dataset.agReady = 'true';
      const input = quantity.querySelector('.ag-quantity__input');
      if (!input) return;
      const changeQuantity = (direction) => {
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const step = Number(input.step || 1);
        const current = Number(input.value || min);
        input.value = String(Math.min(max, Math.max(min, current + direction * step)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      quantity.querySelector('[data-ag-quantity-minus]')?.addEventListener('click', () => changeQuantity(-1));
      quantity.querySelector('[data-ag-quantity-plus]')?.addEventListener('click', () => changeQuantity(1));
    });
    scope.querySelectorAll('[data-ag-faq-button]:not([data-ag-ready])').forEach((button) => {
      button.dataset.agReady = 'true';
      button.addEventListener('click', () => {
        const item = button.closest('.ag-faq__item');
        const answer = document.getElementById(button.getAttribute('aria-controls'));
        if (!item || !answer) return;
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        item.classList.toggle('is-open', !open);
        answer.hidden = open;
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target?.querySelector?.('[data-ag-activity]');
    destroyActivityWidgets(event.target?.querySelector?.('[data-ag-activity]'));
  });
})();
